import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router'

import Moment from 'moment'

const Item = props => (
  <tr>
    <td> {parseInt(props.skip, 0) + props.indexKey + 1} </td>
    <td> {Moment(`${props.row.createdAt}`).format('MMMM, DD YYYY')} </td>
    <td> <span>{props.row.profile.profileId} </span></td>
    <td> <span>{props.row.companyLegalName} </span></td>
    <td>
      <span> <Link to={`/profiles/${props.row.profile.profileId}`}>
        Detail
      </Link> </span>
    </td>
  </tr>
)

Item.defaultProps = {
  row: {
    id: '',
    createdAt: '',
    profile: {
      profileId: '',
    },
    companyLegalName: '',
    address: '',
    taxNumber: '',
    taxUrl: '',
  },
  financeStatus: {},
  skip: 0,
  indexKey: 0,
}

Item.propTypes = {
  row: PropTypes.shape({
    id: PropTypes.string.isRequired,
    createdAt: PropTypes.string.isRequired,
    profile: PropTypes.shape({
      profileId: PropTypes.string.isRequired,
    }).isRequired,
    status: PropTypes.number,
    companyLegalName: PropTypes.string.isRequired,
  }).isRequired,
  skip: PropTypes.number.isRequired,
  indexKey: PropTypes.number.isRequired,
}

export default Item
